export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<div class="${this.classes.containerClasses}">
      <wfs-button
        href="${this.content.link}"
        ${this.content.event ? 'event="'+this.content.event+'"' : ''}
        ${this.content.eventData ? 'data="'+this.content.eventData+'"' : ''}
        id="${this.ids.id}"
        class="wf-inline-block ${this.classes.classes}"
      >${this.content.text}</wfs-button>
    </div>`
  }
}